import { withHandlers, withProps, compose } from 'recompose'
import Checkbox from 'components/common/FormElements/Checkbox/Checkbox'

const withMapProps = withProps(({ label, count }) => ({
  label: count ? `${label} (${count})` : label
}))

const withOnChangeHandlers = withHandlers({
  onChange: ({ onSelect, ...props }) => event => onSelect(props, event)
})

const withCheckboxProps = withProps(({
  selected
}) => ({
  value: selected,
  margin: '17px 0 0'
}))

export default compose(
  withMapProps,
  withOnChangeHandlers,
  withCheckboxProps
)(Checkbox)
